/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SupportingDocumentViewModel } from './SupportingDocumentViewModel';
import {
    SupportingDocumentViewModelFromJSON,
    SupportingDocumentViewModelFromJSONTyped,
    SupportingDocumentViewModelToJSON,
} from './SupportingDocumentViewModel';

/**
 * 
 * @export
 * @interface ResultOfSupportingDocumentViewModel
 */
export interface ResultOfSupportingDocumentViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {SupportingDocumentViewModel}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    data?: SupportingDocumentViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSupportingDocumentViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfSupportingDocumentViewModel interface.
 */
export function instanceOfResultOfSupportingDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfSupportingDocumentViewModelFromJSON(json: any): ResultOfSupportingDocumentViewModel {
    return ResultOfSupportingDocumentViewModelFromJSONTyped(json, false);
}

export function ResultOfSupportingDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSupportingDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : SupportingDocumentViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfSupportingDocumentViewModelToJSON(value?: ResultOfSupportingDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': SupportingDocumentViewModelToJSON(value.data),
        'Count': value.count,
    };
}

